function initialValues(props) {
  const { record = {} } = props;

  return {
    id: record?.id || null,
    accountId: record?.accountId || null,
    firstName: record?.firstName || '',
    lastName: record?.lastName || '',
    birthDay: record?.birthDay || null,
    birthMonth: record?.birthMonth || null,
    birthYear: record?.birthYear || null,
  };
}

export default initialValues;
